<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="inventory"
    max-width="600px"
    retain-focus
    v-on:click:outside="goToShow"
    v-on:keydown.esc="$router.push('/rawmaterial')"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Add Quantity</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="editForm" v-model="createValid">
          <v-text-field
            :rules="validationRules.name"
            v-model="editFields.name"
            label="Raw Material Name*"
            required
            name="name"
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveRawMaterialInventory"
            ref="name"
            tabindex="0"
            :disabled="true"
          />
          <v-text-field
            :rules="validationRules.cost"
            v-model="editFields.cost"
            label="Cost"
            required
            name="cost"
            :error-messages="inputErrorMessages('cost')"
            v-on:keyup.enter="saveRawMaterialInventory"
            ref="cost"
            tabindex="1"
            :disabled="true"
          />
          <v-text-field
            :rules="validationRules.quantity"
            v-model="editFields.quantity"
            label="Quantity/Weight"
            required
            name="quantity"
            :error-messages="inputErrorMessages('quantity')"
            v-on:keyup.enter="saveRawMaterialInventory"
            ref="quantity"
            tabindex="2"
          ></v-text-field>
          <v-select
            :rules="validationRules.unit_type"
            v-model="editFields.unit_type"
            :items="units"
            item-text="name"
            item-value="name"
            label="Unit"
            required
            name="unit_type"
            :error-messages="inputErrorMessages('unit_type')"
            v-on:keyup.enter="saveRawMaterialInventory"
            ref="unit_type"
            tabindex="3"
            :disabled="true"
          ></v-select>
          <v-select
            :rules="validationRules.supplier_id"
            v-model="editFields.supplier_id"
            :items="suppliers"
            item-text="company_name"
            item-value="id"
            label="Supplier"
            required
            name="supplier_id"
            :error-messages="inputErrorMessages('supplier_id')"
            v-on:keyup.enter="saveRawMaterialInventory"
            ref="supplier_id"
            tabindex="4"
            :disabled="true"
          ></v-select>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveRawMaterialInventory">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      loading: false,
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        quantity: [
          v => !!v || this.rem('Quantity'),
          v => v > 0 || 'Quantity should be greater than 0'
        ]
      },
      errorMessages: {},
      editFields: {
        quantity: 0
      }
    };
  },
  computed: {
    ...mapState({
      dataloading: state => state.Supplier.getRawMaterialLoading,
      suppliers: state => state.Supplier.plainsuppliers,
      units: state => state.Unit.units,
      rawmaterial(state) {
        if (typeof state.RawMaterial.rawMaterial.data == 'undefined') {
          return {
            name: '',
            cost: 0,
            quantity: 0,
            unit_type: 0,
            supplier_id: undefined
          };
        }
        return state.RawMaterial.rawMaterial.data;
      },
      units: state => state.Unit.units
    })
  },
  watch: {
    rawmaterial(value) {
      this.editFields.name = value.name;
      this.editFields.cost = value.cost;
      //this.editFields.quantity = value.quantity;
      this.editFields.unit_type = value.unit_type;
      this.editFields.supplier_id = value.supplier_id;
      //this.editFields.meta = JSON.parse(value.meta);
    }
  },
  mounted() {
    this['Supplier/fetchSuppliers']({ dontPaginate: false });
    this['RawMaterial/getRawMaterial']({ id: this.$route.params.id });
  },
  props: {
    inventory: false,
    page: 0
  },
  methods: {
    ...mapActions([
      'RawMaterial/fetchRawMaterials',
      'RawMaterial/getRawMaterial',
      'Supplier/fetchSuppliers'
    ]),
    clearCreate() {},
    rem(name) {
      return `${name} is required`;
    },
    rem(cost) {
      return `${cost} is required`;
    },
    rem(quantity) {
      return `${quantity} is required`;
    },
    rem(unit_type) {
      return `${unit_type} is required`;
    },
    rem(supplier_id) {
      return `${supplier_id} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveRawMaterialInventory() {
      if (1 == 1 || this.$refs.editForm.validate()) {
        this.loading = true;
        let tempEditFields = Object.assign({}, this.editFields);
        //tempEditFields.meta = JSON.stringify(tempEditFields.meta);
        axios
          .post(`api/v1/rawmaterial/${this.$route.params.id}/addquantity`, tempEditFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Quantity added...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.editForm.resetValidation();
            this['RawMaterial/getRawMaterial']({ id: this.$route.params.id });
            this.goToShow();
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    goToShow() {
      this.$router.push(`/rawmaterial/${this.$route.params.id}`);
    }
  }
};
</script>
